import type { GenerateEditorCommand } from '@tunasong/plugin-lib'
import { entitiesApi } from '@tunasong/redux'
import type { Agent, Entity, Persisted } from '@tunasong/schemas'

/**
 * "New conversation" (Chat threads per advisor): store when this user started over with the agent. Their panel
 * and the agent's prompt then show and read only what comes after it (`isInUsersAgentChat`); earlier messages are
 * kept, not deleted, and other users' conversations are untouched. Written through the normal entity update:
 * anyone who can chat with an agent has WRITE on it (agent-stream requires it).
 */
export const startNewConversation = async ({
  dispatch,
  agent,
  userId,
  now = new Date(),
}: {
  dispatch: GenerateEditorCommand['globalContext']['dispatch']
  agent: Pick<Persisted<Agent>, 'id' | 'conversationStarts'>
  userId: string
  now?: Date
}) => {
  const conversationStarts = { ...agent.conversationStarts, [userId]: now.toISOString() }
  await dispatch(
    entitiesApi.endpoints.updateEntity.initiate({
      id: agent.id,
      partialEntity: { conversationStarts } as Partial<Entity>,
      eTag: null,
    })
  ).unwrap()
}
